import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NavBar, SpinLoading, Toast } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../../icon';
import { useAuth } from '../../app/providers/AuthProvider';
import { memberApi } from '../../features/member/api/memberApi';
import MemberAvatarManager from '../../Member/AdminEditMember/MemberAvatarManager';
import '../../Member/AdminEditMember/index.css';
import './style.css';

export default function AvatarMember() {
    const location = useLocation();
    const navigate = useNavigate();
    const { memberInfo } = useAuth();
    const stateUserId = location.state?.userId;
    const queryUserId = new URLSearchParams(location.search).get('userId');
    const userId = stateUserId || queryUserId;
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadUserInfo = useCallback(async () => {
        if (!userId) return;
        try {
            const response = await memberApi.getInfo(userId);
            if (response.data?.code !== 200 || !response.data?.data) {
                throw new Error(response.data?.msg || '球员头像资料不存在');
            }
            setUserInfo(response.data.data);
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: error?.response?.data?.msg || error?.message || '头像资料加载失败',
            });
        } finally {
            setLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        if (Number(memberInfo?.admin) !== 1) {
            Toast.show({ icon: 'fail', content: '只有管理员可以审核球员头像' });
            navigate(-1);
            return;
        }
        if (!userId) {
            Toast.show({ icon: 'fail', content: '未找到需要审核的球员' });
            navigate('/avatarAudit', { replace: true });
            return;
        }
        loadUserInfo();
    }, [loadUserInfo, memberInfo?.admin, navigate, userId]);

    const images = useMemo(
        () => Array.isArray(userInfo?.memberImg) ? userInfo.memberImg : [],
        [userInfo?.memberImg]
    );
    const pendingCount = images.filter(item => Number(item.status) === 1).length;
    const approvedCount = images.filter(item => Number(item.status) === 0).length;
    const rejectedCount = images.filter(item => Number(item.status) === 2).length;
    const defaultImage = images.find(item => Number(item.type) === 0);

    return (
        <div className="avatar-member-page has-unified-nav ui-page ui-page--with-nav">
            <NavBar className="unified-navbar fixed" onBack={() => navigate('/avatarAudit')}>
                单人头像审核
            </NavBar>

            {loading ? (
                <div className="am-review-loading">
                    <SpinLoading color="primary" />
                    <span>正在读取头像资料</span>
                </div>
            ) : userInfo ? (
                <main className="am-review-content">
                    <section className="am-review-hero">
                        <div className={`am-review-avatar ${pendingCount > 0 ? 'has-pending' : ''}`}>
                            <img src={defaultImage?.image || Icon.KEPENG_LOGO} alt={userInfo.name || '球员头像'} />
                            {pendingCount > 0 && <i>{pendingCount}</i>}
                        </div>
                        <div className="am-review-hero-copy">
                            <span>PLAYER AVATAR REVIEW</span>
                            <strong>{userInfo.name || '球员头像审核'}</strong>
                            <small>{pendingCount > 0 ? `有 ${pendingCount} 张新头像等待处理` : '当前没有待审核头像'}</small>
                        </div>
                    </section>

                    <section className="am-review-summary">
                        <div className="is-pending"><strong>{pendingCount}</strong><span>待审核</span></div>
                        <div className="is-approved"><strong>{approvedCount}</strong><span>已通过</span></div>
                        <div className="is-rejected"><strong>{rejectedCount}</strong><span>已驳回</span></div>
                    </section>

                    <div className="am-review-manager">
                        <MemberAvatarManager
                            memberId={userId}
                            images={images}
                            onRefresh={loadUserInfo}
                            canAudit
                            adminDirect
                        />
                    </div>
                </main>
            ) : null}
        </div>
    );
}
